import { OVERVIEW, NEWS, EVENTS, BLOG, translate } from "shared/translate";
import {
  BLOG_TYPE,
  EVENT_TYPE,
  LARGE,
  NEWS_TYPE,
  UPDATE_TYPE,
  POSTS_PER_PAGE,
  SMALL,
} from "shared/constants";
import { CardsContainer } from "components/CardsContainer";
import { CategoriesBar } from "components/CategoriesBar";
import { createInternalHref } from "shared/createInternalHref";
import { MaxWidth } from "components/MaxWidth";
import { OverviewIntro } from "components/OverviewIntro";
import { Page } from "components/Page";
import { Pagination } from "components/Pagination";
import { Spacing } from "components/Spacing";
import { useRouter } from "next/router";

function isActiveType(path, type, locale) {
  return (
    createInternalHref({ href: "", locale, type }).slice(0, -1) ===
    createInternalHref({ href: path.slice(1), locale })
  );
}

export const UpdateOverviewPage = ({
  footer,
  intro,
  mirrorPath,
  navigation,
  posts,
  seo,
  title,
}) => {
  const router = useRouter();

  const categories = [
    {
      isActive: false,
      name: translate(OVERVIEW, router.locale),
      type: UPDATE_TYPE,
      slug: "",
    },
    {
      isActive: isActiveType(router.asPath, NEWS_TYPE, router.locale),
      name: translate(NEWS, router.locale),
      type: NEWS_TYPE,
      slug: "",
    },
    {
      isActive: isActiveType(router.asPath, EVENT_TYPE, router.locale),
      name: translate(EVENTS, router.locale),
      type: EVENT_TYPE,
      slug: "",
    },
    {
      isActive: isActiveType(router.asPath, BLOG_TYPE, router.locale),
      name: translate(BLOG, router.locale),
      type: BLOG_TYPE,
      slug: "",
    },
  ];

  const postsPerPage = POSTS_PER_PAGE;
  const pageStart = +router.query.page - 1 || 0;
  const pageEnd = +router.query.page || 1;
  const postStart = postsPerPage * pageStart;
  const postEnd = postsPerPage * pageEnd;

  const postsForPage = posts.slice(postStart, postEnd);

  return (
    <Page
      description={seo?.description || intro}
      footer={footer}
      hasNewsletter
      image={seo?.image}
      mirrorPath={mirrorPath}
      navigation={navigation}
      title={seo?.title || title}
    >
      <MaxWidth size={LARGE}>
        <Spacing size={SMALL}>
          <OverviewIntro description={intro} title={title} />
        </Spacing>
        <CategoriesBar
          items={categories.map(({ isActive, name, slug, type }) => ({
            isActive,
            label: name,
            href: slug,
            type,
          }))}
        />
        <Spacing size={SMALL}>
          <CardsContainer items={postsForPage} />
        </Spacing>
        {posts.length > postsPerPage && (
          <Pagination
            current={+router.query.page || 1}
            total={Math.ceil(posts.length / postsPerPage)}
          />
        )}
      </MaxWidth>
    </Page>
  );
};
